import { FieldError } from "../FieldError";
import { Label } from "../../../../components/ui/label";
import { Input } from "../../../../components/ui/input";
import { Controller } from "react-hook-form";

const formatFein = (value) => {
  const digits = String(value || "").replace(/\D/g, "").slice(0, 9);
  return digits.length > 2 ? `${digits.slice(0, 2)}-${digits.slice(2)}` : digits;
};

export function Fein({ control }) {
  return (
    <div className="space-y-2">
      <Label htmlFor="fein">FEIN / EIN (Federal Employer Identification Number)</Label>
      <Controller
        control={control}
        name="step2.fein"
        render={({ field }) => (
          <Input
            id="fein"
            inputMode="numeric"
            placeholder="XX-XXXXXXX"
            value={formatFein(field.value)}
            onBlur={field.onBlur}
            onChange={(event) => field.onChange(event.target.value.replace(/\D/g, "").slice(0, 9))}
          />
        )}
      />
      <FieldError name="step2.fein" step="step2" control={control} />
    </div>
  );
}
